export default __webpack_public_path__ + "static/media/hurricane-ida-relief-1.0dddea79.png";